export default __webpack_public_path__ + "static/media/Leaders-Black.22b2177b.svg";